import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { ConfiguracionGeneralModel } from '../admin.configuracion-general.module/service/configuracion-general.model';

import * as L from 'leaflet';
import { Icon } from 'leaflet';
import { ConfiguracionGeneralService } from '../admin.configuracion-general.module/service/configuracion-general.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, AfterViewChecked {
  public zoom = 14;
  public latitud: number;
  public longitud: number;
  public configuracion: ConfiguracionGeneralModel = {}

  public map: L.Map;
  private mapInitialized = false; // Para evitar múltiples inicializaciones

  constructor(
    private configuracionService: ConfiguracionGeneralService,
  ) {
  }

  ngOnInit() {
    delete (Icon.Default.prototype as any)._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: 'assets/img/marker-icon-2x.png',
      iconUrl: 'assets/img/marker-icon.png',
      shadowUrl: 'assets/img/marker-shadow.png',
    });

    this.configuracionService.obtenerConfiguracionGeneral()
      .then(configuracion => {
        this.configuracion = configuracion;
      })
  }

  ngAfterViewChecked(): void {
    if (this.configuracion.footerMap === 'leaflet' && !this.mapInitialized) {
      const mapContainer = document.getElementById('map');
      if (mapContainer) {
        this.initLeafletMap();
        this.mapInitialized = true;
      }
    }
  }

  initLeafletMap() {
    this.map = L.map('map').setView([this.configuracion.ubicacionLatitud, this.configuracion.ubicacionLongitud], this.zoom);

    L.tileLayer('https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=PT6gd54A09IjpZGlpOj5',
      {
        maxZoom: 20,
        tileSize: 512,
        zoomOffset: -1,
        attribution:
          '<a href="https://www.maptiler.com/copyright/">© MapTiler</a> © OpenStreetMap contributors'
      }
    ).addTo(this.map);

    L.marker([this.configuracion.ubicacionLatitud, this.configuracion.ubicacionLongitud])
      .addTo(this.map)

    console.log('Mapa Leaflet inicializado');
    setTimeout(() => {
      this.map.invalidateSize(); // Asegura que Leaflet ajuste el tamaño correctamente
    }, 300);
  }

  public placeMarker() {
    console.log('placed');
  }

  public redirect(url: string) {
    window.open(url, '_blank');
  }

  checkIconSocial(red: string) {
    if (this.configuracion[red] != null && this.configuracion[red] != '') {
      return true;
    }
    return false;
  }
}

